"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LEVELS = void 0;
var _cnbuilder = require("cnbuilder");
var _reactI18next = require("react-i18next");
var _ProgressIndicator = _interopRequireDefault(require("../ProgressIndicator"));
var _PasswordStrengthModule = _interopRequireDefault(require("./PasswordStrength.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const LEVELS = exports.LEVELS = ['low', 'medium', 'high', 'very-high', 'very-weak', 'average', 'strong', 'empty']; // New levels (very-weak, average, strong, empty) added. Previous levels kept for backward compatibility.

const PasswordStrength = _ref => {
  let {
    className,
    testAttr,
    currentStep,
    level,
    totalSteps
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "visually-hidden",
      "aria-live": "polite",
      children: t("ui:passwordStrength.".concat(level))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProgressIndicator.default, {
      classNameRoot: (0, _cnbuilder.cnb)(_PasswordStrengthModule.default[level], className),
      classNameProgress: _PasswordStrengthModule.default.level,
      testAttrRoot: testAttr,
      totalSteps: totalSteps
      // updated this way to maintain backward compatibility:
      ,
      currentStep: currentStep || LEVELS.indexOf(level) + 1
    })]
  });
};
PasswordStrength.defaultProps = {
  testAttr: 'password-strength',
  level: 'low',
  totalSteps: 4.5 // default number to maintain backward compatibility
};
var _default = exports.default = PasswordStrength;